import { getSessionToken, isLoggedIn } from "@/api/auth";
import ChatBot from "./ChatBot";
import { Browsers } from "@phosphor-icons/react";
import { TreeStructure } from "@phosphor-icons/react";
import { NewspaperClipping } from "@phosphor-icons/react";
import { useState, useEffect } from "react";
import { AI_DOMAIN, LANGGRAPH_DOMAIN } from "@launchos/shared-utils/env";
import { ChangedComponentTool } from "./LangGraphBot/components/ChangedComponentTool";
import { PageBuilderArtifact } from "./LangGraphBot/components/PageBuilderArtifact";
import { CampaignBuilderArtifact } from "./LangGraphBot/components/CampaignBuilderArtifact";
import { LangGraphBot } from "./LangGraphBot/LangGraphBot";
import { OptinPopup } from "./ChatBot/OptinPopup";

export const OfflineChatBot = () => {
  const [suggestions, setSuggestions] = useState([]);
  const [optInPopupIsShowing, setOptInPopupIsShowing] = useState(false);
  const loadSuggestions = async () => {
    const prompt = "Generate 3 prompt suggestions";
    const response = await fetch(`${AI_DOMAIN}/api/copilot/suggestions`, {
      method: "post",
      body: JSON.stringify({ prompt }),
    });
    const r = response.json();
    const data = await r;
    console.log("Suggestions", data);
    setSuggestions(data.suggestions);
  };

  useEffect(() => {
    loadSuggestions();
  }, []);

  if (Boolean(getSessionToken())) return null;

  return (
    // <div className="h-[100vh] w-full flex items-center justify-center">
    <div>
      {optInPopupIsShowing && (
        <OptinPopup setOptInPopupIsShowing={setOptInPopupIsShowing} />
      )}
      {/* <ChatBot
        showHeader={false}
        title="What can I help you launch today?"
        subtitle="Generate landing pages, sales funnels, copy, and much more."
        pageSettings={{}}
        placeholder="Ask Launch OS a question..."
        suggestions={suggestions.map((itm) => {
          let icon;
          if (itm?.icon === "Browsers") icon = Browsers;
          if (itm?.icon === "TreeStructure") icon = TreeStructure;
          if (itm?.icon === "NewspaperClipping") icon = NewspaperClipping;
          return { ...itm, icon };
        })}
      /> */}
      <LangGraphBot
        // assistantId="40b58130-2439-5a53-9818-dfb7753f3275"
        assistantId="e9a3c5e3-a79b-54b5-8057-da8021ccbf5f"
        apiUrl={LANGGRAPH_DOMAIN}
        title="What can I help you launch today?"
        subtitle="Generate landing pages, sales funnels, copy, research reports, and much more"
        suggestions={suggestions}
        placeholder="Ask Launch OS a question..."
        onBeforeSubmit={async () => {
          const isTheUserLoggedIn = await isLoggedIn();
          console.log("isTheUserLoggedIn", isTheUserLoggedIn);

          if (!isTheUserLoggedIn) {
            setOptInPopupIsShowing(true);
            return false;
          } else {
            return {};
          }
        }}
        artifacts={[
          {
            id: "add_component",
            title: "Add a component",
            component: ChangedComponentTool,
          },
          {
            id: "page_builder",
            title: "Page Builder",
            component: PageBuilderArtifact,
          },
          {
            id: "campaign_builder",
            title: "Campaign Builder",
            component: CampaignBuilderArtifact,
          },
        ]}
      />
    </div>
  );
};
